<template>

    <wrap class="gallery" title="Bildergalerie">

      <figure role="group" class="gallery-list">
        <figure class="gallery-item" v-for="(image,idx) in images" v-bind:key="idx">
          <img :src="image.urlOrig" :alt="image.title" :width="image.size[0]" :height="image.size[1]" />
        </figure>
      </figure>

    </wrap>

</template>

<script>

  import VideoYoutube from '../subparts/VideoYoutube';
  import SubPage from '../layouts/SubPage';

  export default {
    name: "Gallery",
    data() {
      return {
        lightbox: false,
        activeIdx : false
      };
    },
    components: {
      'wrap': SubPage
    },
    props: {
      images : {
        // type: 'Object',
        required: true
      }
    },
    computed: {
      lightboxIsOpen: function () {
        return this.lightbox;
      },
      activeImage : function( ) {
        return this.images[ this.activeIdx ];
      }
    },
    methods: {
      openLightbox: function () {
        // this.activeIdx = key;
        this.lightbox = true;
      },
      closeLightbox : function(){
        // this.activeIdx = false;
        this.lightbox = false;
      },
      nextImage: function(){
        if( this.activeIdx < (this.images.length - 1) )
          this.activeIdx++;
      },
      prevImage: function(){
        if( this.activeIdx > 0 )
          this.activeIdx--;
      },
    }
  };
</script>

<style scoped>

/*  .gallery {
    min-height: 80px;
    padding: 0;
    !*display: flex;*!
    !*flex-direction: column;*!
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #1A2026;
  }
*/
  .gallery-list {
    /*overflow: auto;*/
    /*padding: 12px 0;*/
  }

  .gallery-item {
    margin: 0 0 25px;
  }

  .gallery-item img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/blocks/Gallery.vue